/**
 * Bor színe   * RED - vörös   * WHITE - fehér   * ROSE - rosé   * SILLER - siller
 */
export type WineColor = 'RED' | 'WHITE' | 'ROSE' | 'SILLER';

export const WineColor = {
  Red: 'RED' as WineColor,
  White: 'WHITE' as WineColor,
  Rose: 'ROSE' as WineColor,
  Siller: 'SILLER' as WineColor,
};
